import { useNode } from '@craftjs/core';
import { FormDividingLineComponent } from 'src/features/generalForms/builder/types/DividingLine';

export const FormDividingLine: FormDividingLineComponent = () => {
  const { styles } = useNode((node) => ({
    styles: node.data.custom,
  }));

  const { paddingTop, paddingBottom, ...restStyles } = styles;

  return (
    <div
      style={{
        paddingTop: paddingTop,
        paddingBottom: paddingBottom,
        boxSizing: 'border-box',
      }}
    >
      <div style={{ ...restStyles, borderBottom: 0 }} />
    </div>
  );
};
